import { Capacitor } from "@capacitor/core";
import { StateCreator } from "zustand";

import { isMobileOrTablet } from "@/shared/utils/device";
import { getPlatform } from "@/shared/utils/device";
import { DevicePlatform, DeviceType } from "@/types/common";

export type ViewMode = "grid" | "list";

export interface DeviceSlice {
  device: {
    isActive: boolean;
    isNative: boolean;
    platform: DevicePlatform;
    type: DeviceType;

    set: (setting: Omit<Partial<DeviceSlice["device"]>, "set">) => void;
  };
}

const createDeviceSlice: StateCreator<DeviceSlice, [], [], DeviceSlice> = (set) => ({
  device: {
    isActive: true,
    isNative: Capacitor.isNativePlatform(),
    type: isMobileOrTablet() ? "mobile" : "desktop",
    platform: getPlatform(),

    set: (device) => set((state) => ({ device: { ...state.device, ...device } })),
  },
});

export default createDeviceSlice;
